import { apiClient } from '@/services/ApiClient.js'

export class RetailerStockOutputService {
  getStockOutputsByInput(inputId, query) {
    return apiClient
      .get('retailer-stock-inputs/' + inputId + '/stock-outputs', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  refundStockOutput(orderId) {
    return apiClient
      .delete('retailer-stock-outputs/refund-stock-output/' + orderId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  exportRetailerStockOutputs(query) {
    return apiClient
      .get('retailer-stock-outputs/export', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  convertToShortSale(outputId) {
    return apiClient
      .patch('retailer-stock-outputs/' + outputId + '/convert-to-short-sale')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
